/*
 * A batch of pictures worked through one after another -- Spore analysis's
 * micrographs (components/workbench/microscopy/MicroscopyMode.js) and Culture analysis's dish
 * photographs (components/workbench/culture/CultureMode.js). {source, label, images: [...]
 * each with `analysed`, carry?}; the page names an image by its own id key
 * (image_id, photo_id). Kept for the browser tab (sessionStorage) so a reload
 * goes on with it; hooks/useStoredBatch.js holds it in React.
 */

/** The stored batch, or null when there is none (or it holds no image). */
export function readBatch(key) {
  try {
    const stored = JSON.parse(sessionStorage.getItem(key) || 'null');
    return stored && Array.isArray(stored.images) && stored.images.length ? stored : null;
  } catch {
    return null;
  }
}

/** Keeps `batch` for the tab; null forgets it. */
export function writeBatch(key, batch) {
  try {
    if (batch) sessionStorage.setItem(key, JSON.stringify(batch));
    else sessionStorage.removeItem(key);
  } catch { /* private window: the batch lasts as long as the page */ }
}

/** The first image not analysed yet, else the first; -1 for none. */
export function firstIndexToAnalyse(images) {
  if (!images || !images.length) return -1;
  const i = images.findIndex(img => !img.analysed);
  return i >= 0 ? i : 0;
}

/** The next image not analysed yet after `from`, going round (`from` itself last); -1 when every one is. */
export function nextIndexToAnalyse(images, from) {
  const n = images ? images.length : 0;
  for (let k = 1; k <= n; k += 1) {
    const i = (((from + k) % n) + n) % n;
    if (!images[i].analysed) return i;
  }
  return -1;
}

/** The batch with the images whose `idKey` is in `ids` marked analysed; the same object when none changes. */
export function markAnalysed(batch, ids, idKey) {
  if (!batch) return batch;
  const wanted = new Set(ids);
  let changed = false;
  const images = batch.images.map((img) => {
    if (!wanted.has(img[idKey]) || img.analysed) return img;
    changed = true;
    return { ...img, analysed: true };
  });
  return changed ? { ...batch, images } : batch;
}
